
import moment from "moment";
import 'moment/locale/fr';
import 'moment/locale/en-gb';
import { numberToDateObject } from "./DateUtils";
import { formatNumberToCurrency } from "./CurrencyUtils";
import { SectionConfig } from "../dto/ClientConfig";
import { ExternalSystemElement } from "../dto/ExternalSystemElement";
import { Currency } from "../dto/Brief";


export function GenerateSectionDescription(inputValues: any, sectionName: string, locale: string): React.ReactNode {
    moment.locale(locale);

    if (sectionName === "txt_general_criteria")
        return GenerateGeneralSectionDescription(inputValues, locale);
    else if (sectionName === "txt_digital_section_name")
        return GenerateDigitalSectionDescription(inputValues, locale)
    else if (sectionName === "txt_duration_criteria")
        return GenerateDurationSectionDescription(inputValues, locale);

    return <></>;
}

function GenerateDurationSectionDescription(inputValues: any, locale: string): React.ReactNode {
    return (
        <>
            {inputValues.grpPerFormat && inputValues.grpPerFormat.length > 0 && <><span>{(inputValues.grpPerFormat as any[]).map((g, i) => <><span key={i}>{g.format}s | {Number.parseFloat(g.grpRepartitionPercent).toFixed(2)} %</span><br/></>)}</span><br/></>}
        </>
    );
}

function pruneText(text: string, maxLength: number): string {
    if (text.length > maxLength)
        return text.substring(0, maxLength) + "...";
    return text;
}

function GenerateGeneralSectionDescription(inputValues: any, locale: string): React.ReactNode {
    return (
        <>
            {inputValues.selectedAgency && <><span>{pruneText(inputValues.selectedAgency.name, 20)}</span><br/></>}
            {inputValues.selectedAdvertiser && <><span>{pruneText(inputValues.selectedAdvertiser.name, 20)}</span><br/></>}
            {inputValues.selectedProduct && <><span>{pruneText(inputValues.selectedProduct.name, 20)}</span><br/></>}
            {inputValues.selectedSector && <><span>{pruneText(inputValues.selectedSector.name, 20)}</span><br/></>}
            {inputValues.selectedCountry && <><span>{pruneText(inputValues.selectedCountry.name, 20)}</span><br/></>}
            {inputValues.selectedMediaChannels && <>{(inputValues.selectedMediaChannels as any[]).map((mc, i) => <><span key={i}>{mc.name}</span><br/></>)}</>}
            {inputValues.selectedTarget && <><span>{pruneText(inputValues.selectedTarget.name, 20)}</span><br/></>}
            {inputValues.selectedFormats && <><span>{(inputValues.selectedFormats as number[]).join(", ")}</span><br/></>}
            {inputValues.startDate && inputValues.endDate && <><span>{moment(numberToDateObject(inputValues.startDate)).format("L")} - {moment(numberToDateObject(inputValues.endDate)).format("L")}</span><br/></>}
            {inputValues.selectedDays && <><span>{(inputValues.selectedDays as number[]).map(d => moment().day(d).format("dd").toLocaleUpperCase()).join(", ")}</span><br/></>}
            {inputValues.selectedCurrency && <><span>{pruneText(inputValues.selectedCurrency.name, 20)}</span><br/></>}
            {/* {inputValues.netBudget && inputValues.netBudget > 0 && <><span>{formatNumberToCurrency(inputValues.netBudget, inputValues.selectedCurrency)}</span><br/></>} */}
            {inputValues.fullBudget && inputValues.fullBudget > 0 && <><span>{formatNumberToCurrency(inputValues.fullBudget, inputValues.selectedCurrency)}</span><br/></>}
            {inputValues.sellingStrategyType && inputValues.sellingStrategyType.id && inputValues.sellingStrategyValue > 0 && <><span>{inputValues.sellingStrategyValue} { inputValues.sellingStrategyType.id === "discount" ? "%" : ""}</span><br/></>}
            {inputValues.sellingStrategyType && (inputValues.sellingStrategyType.id === "costgrp-campaign" || inputValues.sellingStrategyType.id === "discount" || inputValues.sellingStrategyType.id === "spotcount") && inputValues.discountRate && <><span>{inputValues.discountRate} %</span><br/></>}
        </>
    );
}

export function checkSectionByMedia (section: SectionConfig, medias: ExternalSystemElement[] | null): boolean {
    // default sections
    if (!("mediaIds" in section)) return true
    if (section?.mediaIds?.length === 0) return true

    // null media, maybe when loading brief ?
    if (!medias) return  false

    // sections specific to some medias
    return medias.map((media) => section?.mediaIds?.includes(media.id)).some(Boolean)
}

export function GenerateDigitalSectionDescription (inputValues: any, locale: string): React.ReactNode {
    return <>
        {inputValues.digitalBudget && inputValues.digitalBudget > 0 && <><span>{formatNumberToCurrency(inputValues.digitalBudget, inputValues.selectedCurrency)}</span><br/></>}
        {inputValues.digitalTarget && <>{(inputValues.digitalTarget as any[]).map((item, i) => <><span key={i}>{item.name}</span><br/></>)}</>}
        {inputValues.digitalFormat && <>{(inputValues.digitalFormat as any[]).map((item, i) => <><span key={i}>{item.name}</span><br/></>)}</>}
        {inputValues.digitalContent && <><span>{pruneText(inputValues.digitalContent.name, 20)}</span><br/></>}
        {inputValues.digitalDevice && <>{(inputValues.digitalDevice as any[]).map((item, i) => <><span key={i}>{item.name}</span><br/></>)}</>}
    </>
}